// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1-mIx","placeholdersHeader":"styles_placeholdersHeader__3JoHA","editorStyle":"styles_editorStyle__2rAaH","placeholdersBox":"styles_placeholdersBox__298va"};